import { render } from "./SalesTable.html?vue&type=template&id=f5c783e6"
import script from "./SalesTable.ts?vue&type=script&lang=ts"
export * from "./SalesTable.ts?vue&type=script&lang=ts"

import "./SalesTable.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script